"use strict";
/*
 * HSCarousel
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSCarousel = /** @class */ (function (_super) {
    __extends(HSCarousel, _super);
    function HSCarousel(el, options) {
        var _a, _b, _c, _d, _e;
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-carousel');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.currentIndex = concatOptions.currentIndex || 0;
        _this.loadingClasses = concatOptions.loadingClasses
            ? "".concat(concatOptions.loadingClasses).split(',')
            : null;
        _this.dotsItemClasses = concatOptions.dotsItemClasses
            ? concatOptions.dotsItemClasses
            : null;
        _this.isAutoHeight =
            typeof concatOptions.isAutoHeight !== 'undefined'
                ? concatOptions.isAutoHeight
                : false;
        _this.isAutoPlay =
            typeof concatOptions.isAutoPlay !== 'undefined'
                ? concatOptions.isAutoPlay
                : false;
        _this.isCentered =
            typeof concatOptions.isCentered !== 'undefined'
                ? concatOptions.isCentered
                : false;
        _this.isDraggable =
            typeof concatOptions.isDraggable !== 'undefined'
                ? concatOptions.isDraggable
                : false;
        _this.isInfiniteLoop =
            typeof concatOptions.isInfiniteLoop !== 'undefined'
                ? concatOptions.isInfiniteLoop
                : false;
        _this.isRTL =
            typeof concatOptions.isRTL !== 'undefined' ? concatOptions.isRTL : false;
        _this.isSnap =
            typeof concatOptions.isSnap !== 'undefined'
                ? concatOptions.isSnap
                : false;
        _this.hasSnapSpacers =
            typeof concatOptions.hasSnapSpacers !== 'undefined'
                ? concatOptions.hasSnapSpacers
                : true;
        _this.speed = concatOptions.speed || 4000;
        _this.updateDelay = concatOptions.updateDelay || 0;
        _this.slidesQty = concatOptions.slidesQty || 1;
        _this.loadingClassesRemove = ((_a = _this.loadingClasses) === null || _a === void 0 ? void 0 : _a[0])
            ? _this.loadingClasses[0].split(' ')
            : 'opacity-0';
        _this.loadingClassesAdd = ((_b = _this.loadingClasses) === null || _b === void 0 ? void 0 : _b[1])
            ? _this.loadingClasses[1].split(' ')
            : '';
        _this.afterLoadingClassesAdd = ((_c = _this.loadingClasses) === null || _c === void 0 ? void 0 : _c[2])
            ? _this.loadingClasses[2].split(' ')
            : '';
        _this.container = _this.el.querySelector('.hs-carousel') || null;
        _this.inner = _this.el.querySelector('.hs-carousel-body') || null;
        _this.slides = _this.el.querySelectorAll('.hs-carousel-slide') || [];
        _this.prev = _this.el.querySelector('.hs-carousel-prev') || null;
        _this.next = _this.el.querySelector('.hs-carousel-next') || null;
        _this.dots = _this.el.querySelector('.hs-carousel-pagination') || null;
        _this.info = _this.el.querySelector('.hs-carousel-info') || null;
        _this.infoTotal =
            ((_d = _this === null || _this === void 0 ? void 0 : _this.info) === null || _d === void 0 ? void 0 : _d.querySelector('.hs-carousel-info-total')) || null;
        _this.infoCurrent =
            ((_e = _this === null || _this === void 0 ? void 0 : _this.info) === null || _e === void 0 ? void 0 : _e.querySelector('.hs-carousel-info-current')) || null;
        _this.sliderWidth = _this.el.getBoundingClientRect().width;
        // Drag events' help variables
        _this.isDragging = false;
        _this.dragStartX = null;
        _this.initialTranslateX = null;
        // Touch events' help variables
        _this.touchX = {
            start: 0,
            end: 0,
        };
        // Resize events' help variables
        _this.resizeContainer = document.querySelector('body');
        _this.resizeContainerWidth = 0;
        _this.init();
        return _this;
    }
    HSCarousel.prototype.setIsSnap = function () {
        var _this = this;
        var containerRect = this.container.getBoundingClientRect();
        var containerCenter = containerRect.left + containerRect.width / 2;
        var closestElement = null;
        var closestElementIndex = null;
        var closestDistance = Infinity;
        Array.from(this.inner.children).forEach(function (child) {
            var childRect = child.getBoundingClientRect();
            var innerContainerRect = _this.inner.getBoundingClientRect();
            var childCenter = childRect.left + childRect.width / 2 - innerContainerRect.left;
            var distance = Math.abs(containerCenter - (innerContainerRect.left + childCenter));
            if (distance < closestDistance) {
                closestDistance = distance;
                closestElement = child;
            }
        });
        if (closestElement) {
            closestElementIndex = Array.from(this.slides).findIndex(function (el) { return el === closestElement; });
        }
        this.setIndex(closestElementIndex);
        if (this.dots)
            this.setCurrentDot();
    };
    HSCarousel.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsCarouselCollection, this);
        if (this.inner) {
            this.calculateWidth();
            if (this.isDraggable && !this.isSnap)
                this.initDragHandling();
        }
        if (this.prev)
            this.prev.addEventListener('click', function () {
                _this.goToPrev();
                if (_this.isAutoPlay) {
                    _this.resetTimer();
                    _this.setTimer();
                }
            });
        if (this.next)
            this.next.addEventListener('click', function () {
                _this.goToNext();
                if (_this.isAutoPlay) {
                    _this.resetTimer();
                    _this.setTimer();
                }
            });
        if (this.dots)
            this.initDots();
        if (this.info)
            this.buildInfo();
        if (this.slides.length) {
            this.addCurrentClass();
            if (!this.isInfiniteLoop)
                this.addDisabledClass();
            if (this.isAutoPlay)
                this.autoPlay();
        }
        setTimeout(function () {
            var _a, _b;
            if (_this.isSnap)
                _this.setIsSnap();
            if (_this.loadingClassesRemove) {
                if (typeof _this.loadingClassesRemove === 'string')
                    _this.inner.classList.remove(_this.loadingClassesRemove);
                else
                    (_a = _this.inner.classList).remove.apply(_a, _this.loadingClassesRemove);
            }
            if (_this.loadingClassesAdd) {
                if (typeof _this.loadingClassesAdd === 'string')
                    _this.inner.classList.add(_this.loadingClassesAdd);
                else
                    (_b = _this.inner.classList).add.apply(_b, _this.loadingClassesAdd);
            }
            if (_this.inner && _this.afterLoadingClassesAdd) {
                setTimeout(function () {
                    var _a;
                    if (typeof _this.afterLoadingClassesAdd === 'string')
                        _this.inner.classList.add(_this.afterLoadingClassesAdd);
                    else
                        (_a = _this.inner.classList).add.apply(_a, _this.afterLoadingClassesAdd);
                });
            }
        }, 400);
        if (this.isSnap) {
            this.container.addEventListener('scroll', function () {
                clearTimeout(_this.isScrolling);
                _this.isScrolling = setTimeout(function () {
                    _this.setIsSnap();
                }, 100);
            });
        }
        this.el.classList.add('init');
        if (!this.isSnap) {
            this.el.addEventListener('touchstart', function (evt) {
                _this.touchX.start = evt.changedTouches[0].screenX;
            });
            this.el.addEventListener('touchend', function (evt) {
                _this.touchX.end = evt.changedTouches[0].screenX;
                _this.detectDirection();
            });
        }
        this.observeResize();
    };
    HSCarousel.prototype.initDragHandling = function () {
        var scrollableElement = this.inner;
        if (scrollableElement) {
            scrollableElement.addEventListener('mousedown', this.handleDragStart.bind(this));
            scrollableElement.addEventListener('touchstart', this.handleDragStart.bind(this), { passive: true });
            document.addEventListener('mousemove', this.handleDragMove.bind(this));
            document.addEventListener('touchmove', this.handleDragMove.bind(this), {
                passive: false,
            });
            document.addEventListener('mouseup', this.handleDragEnd.bind(this));
            document.addEventListener('touchend', this.handleDragEnd.bind(this));
        }
    };
    HSCarousel.prototype.getTranslateXValue = function () {
        var _a;
        var transformMatrix = window.getComputedStyle(this.inner).transform;
        if (transformMatrix !== 'none') {
            var matrixValues = (_a = transformMatrix
                .match(/matrix.*\((.+)\)/)) === null || _a === void 0 ? void 0 : _a[1].split(', ');
            if (matrixValues) {
                var translateX = parseFloat(matrixValues.length === 6 ? matrixValues[4] : matrixValues[12]);
                if (this.isRTL)
                    translateX = -translateX;
                return isNaN(translateX) || translateX === 0 ? 0 : -translateX;
            }
        }
        return 0;
    };
    HSCarousel.prototype.removeClickEventWhileDragging = function (evt) {
        evt.preventDefault();
    };
    HSCarousel.prototype.handleDragStart = function (evt) {
        evt.preventDefault();
        this.isDragging = true;
        this.dragStartX = this.getEventX(evt);
        this.initialTranslateX = this.isRTL
            ? this.getTranslateXValue()
            : -this.getTranslateXValue();
        this.inner.classList.add('dragging');
    };
    HSCarousel.prototype.handleDragMove = function (evt) {
        var _this = this;
        if (!this.isDragging)
            return;
        this.inner.querySelectorAll('a:not(.prevented-click)').forEach(function (el) {
            el.classList.add('prevented-click');
            el.addEventListener('click', _this.removeClickEventWhileDragging);
        });
        var currentX = this.getEventX(evt);
        var deltaX = currentX - this.dragStartX;
        if (this.isRTL)
            deltaX = -deltaX;
        var newTranslateX = this.initialTranslateX + deltaX;
        var newTranslateXFunc = function () {
            var calcWidth = (_this.sliderWidth * _this.slides.length) / _this.getCurrentSlidesQty() -
                _this.sliderWidth;
            var containerWidth = _this.sliderWidth;
            var itemWidth = containerWidth / _this.getCurrentSlidesQty();
            var centeredOffset = (containerWidth - itemWidth) / 2;
            var limitStart = _this.isCentered ? centeredOffset : 0;
            if (_this.isCentered)
                calcWidth = calcWidth + centeredOffset;
            var limitEnd = -calcWidth;
            if (_this.isRTL) {
                if (newTranslateX < limitStart)
                    return limitStart;
                if (newTranslateX > calcWidth)
                    return limitEnd;
                else
                    return -newTranslateX;
            }
            else {
                if (newTranslateX > limitStart)
                    return limitStart;
                else if (newTranslateX < -calcWidth)
                    return limitEnd;
                else
                    return newTranslateX;
            }
        };
        this.setTranslate(newTranslateXFunc());
    };
    HSCarousel.prototype.handleDragEnd = function () {
        var _this = this;
        if (!this.isDragging)
            return;
        this.isDragging = false;
        var containerWidth = this.sliderWidth;
        var itemWidth = containerWidth / this.getCurrentSlidesQty();
        var currentTranslateX = this.getTranslateXValue();
        var closestIndex = Math.round(currentTranslateX / itemWidth);
        if (this.isRTL)
            closestIndex = Math.round(currentTranslateX / itemWidth);
        this.inner.classList.remove('dragging');
        setTimeout(function () {
            _this.calculateTransform(closestIndex);
            if (_this.dots)
                _this.setCurrentDot();
            _this.dragStartX = null;
            _this.initialTranslateX = null;
            _this.inner.querySelectorAll('a.prevented-click').forEach(function (el) {
                el.classList.remove('prevented-click');
                el.removeEventListener('click', _this.removeClickEventWhileDragging);
            });
        });
    };
    HSCarousel.prototype.getEventX = function (event) {
        return event instanceof MouseEvent
            ? event.clientX
            : event.touches[0].clientX;
    };
    HSCarousel.prototype.getCurrentSlidesQty = function () {
        var _this = this;
        if (typeof this.slidesQty === 'object') {
            var windowWidth_1 = document.body.clientWidth;
            var currentRes_1 = 0;
            Object.keys(this.slidesQty).forEach(function (key) {
                if (windowWidth_1 >=
                    (typeof key + 1 === 'number'
                        ? _this.slidesQty[key]
                        : constants_1.BREAKPOINTS[key]))
                    currentRes_1 = _this.slidesQty[key];
            });
            return currentRes_1;
        }
        else {
            return this.slidesQty;
        }
    };
    HSCarousel.prototype.buildSnapSpacers = function () {
        var existingBefore = this.inner.querySelector('.hs-snap-before');
        var existingAfter = this.inner.querySelector('.hs-snap-after');
        if (existingBefore)
            existingBefore.remove();
        if (existingAfter)
            existingAfter.remove();
        var containerWidth = this.sliderWidth;
        var itemWidth = containerWidth / this.getCurrentSlidesQty();
        var spacerWidth = containerWidth / 2 - itemWidth / 2;
        var before = (0, utils_1.htmlToElement)("<div class=\"hs-snap-before\" style=\"height: 100%; width: ".concat(spacerWidth, "px\"></div>"));
        var after = (0, utils_1.htmlToElement)("<div class=\"hs-snap-after\" style=\"height: 100%; width: ".concat(spacerWidth, "px\"></div>"));
        this.inner.prepend(before);
        this.inner.appendChild(after);
    };
    HSCarousel.prototype.initDots = function () {
        if (this.el.querySelectorAll('.hs-carousel-pagination-item').length)
            this.setDots();
        else
            this.buildDots();
        if (this.dots)
            this.setCurrentDot();
    };
    HSCarousel.prototype.buildDots = function () {
        this.dots.innerHTML = '';
        var slidesQty = !this.isCentered && this.slidesQty
            ? this.slides.length - (this.getCurrentSlidesQty() - 1)
            : this.slides.length;
        for (var i = 0; i < slidesQty; i++) {
            var singleDot = this.buildSingleDot(i);
            this.dots.append(singleDot);
        }
    };
    HSCarousel.prototype.setDots = function () {
        var _this = this;
        this.dotsItems = this.dots.querySelectorAll('.hs-carousel-pagination-item');
        this.dotsItems.forEach(function (dot, ind) {
            var targetIndex = dot.getAttribute('data-carousel-pagination-item-target');
            _this.singleDotEvents(dot, targetIndex ? +targetIndex : ind);
        });
    };
    HSCarousel.prototype.goToCurrentDot = function () {
        var container = this.dots;
        var containerRect = container.getBoundingClientRect();
        var containerScrollLeft = container.scrollLeft;
        var containerScrollTop = container.scrollTop;
        var containerWidth = container.clientWidth;
        var containerHeight = container.clientHeight;
        var item = this.dotsItems[this.currentIndex];
        var itemRect = item.getBoundingClientRect();
        var itemLeft = itemRect.left - containerRect.left + containerScrollLeft;
        var itemRight = itemLeft + item.clientWidth;
        var itemTop = itemRect.top - containerRect.top + containerScrollTop;
        var itemBottom = itemTop + item.clientHeight;
        var scrollLeft = containerScrollLeft;
        var scrollTop = containerScrollTop;
        if (itemLeft < containerScrollLeft ||
            itemRight > containerScrollLeft + containerWidth) {
            scrollLeft = itemRight - containerWidth;
        }
        if (itemTop < containerScrollTop ||
            itemBottom > containerScrollTop + containerHeight) {
            scrollTop = itemBottom - containerHeight;
        }
        container.scrollTo({
            left: scrollLeft,
            top: scrollTop,
            behavior: 'smooth',
        });
    };
    HSCarousel.prototype.buildInfo = function () {
        if (this.infoTotal)
            this.setInfoTotal();
        if (this.infoCurrent)
            this.setInfoCurrent();
    };
    HSCarousel.prototype.setInfoTotal = function () {
        this.infoTotal.innerText = "".concat(this.slides.length);
    };
    HSCarousel.prototype.setInfoCurrent = function () {
        this.infoCurrent.innerText = "".concat(this.currentIndex + 1);
    };
    HSCarousel.prototype.buildSingleDot = function (ind) {
        var singleDot = (0, utils_1.htmlToElement)('<span></span>');
        if (this.dotsItemClasses)
            (0, utils_1.classToClassList)(this.dotsItemClasses, singleDot);
        this.singleDotEvents(singleDot, ind);
        return singleDot;
    };
    HSCarousel.prototype.singleDotEvents = function (dot, ind) {
        var _this = this;
        dot.addEventListener('click', function () {
            _this.goTo(ind);
            if (_this.isAutoPlay) {
                _this.resetTimer();
                _this.setTimer();
            }
        });
    };
    HSCarousel.prototype.observeResize = function () {
        var _this = this;
        var resizeObserver = new ResizeObserver((0, utils_1.debounce)(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var newWidth = entry.contentRect.width;
                if (newWidth !== _this.resizeContainerWidth) {
                    _this.recalculateWidth();
                    if (_this.dots)
                        _this.initDots();
                    _this.addCurrentClass();
                    _this.resizeContainerWidth = newWidth;
                }
            }
        }, this.updateDelay));
        resizeObserver.observe(this.resizeContainer);
    };
    HSCarousel.prototype.calculateWidth = function () {
        var _this = this;
        if (!this.isSnap)
            this.inner.style.width = "".concat((this.sliderWidth * this.slides.length) / this.getCurrentSlidesQty(), "px");
        this.slides.forEach(function (el) {
            el.style.width = "".concat(_this.sliderWidth / _this.getCurrentSlidesQty(), "px");
        });
        this.calculateTransform();
    };
    HSCarousel.prototype.addCurrentClass = function () {
        var _this = this;
        if (this.isSnap) {
            var itemsQty = Math.floor(this.getCurrentSlidesQty() / 2);
            for (var i = 0; i < this.slides.length; i++) {
                var slide = this.slides[i];
                if (i <= this.currentIndex + itemsQty &&
                    i >= this.currentIndex - itemsQty)
                    slide.classList.add('active');
                else
                    slide.classList.remove('active');
            }
        }
        else {
            var maxIndex_1 = this.isCentered
                ? this.currentIndex +
                    this.getCurrentSlidesQty() +
                    (this.getCurrentSlidesQty() - 1)
                : this.currentIndex + this.getCurrentSlidesQty();
            this.slides.forEach(function (el, i) {
                if (i >= _this.currentIndex && i < maxIndex_1) {
                    el.classList.add('active');
                }
                else {
                    el.classList.remove('active');
                }
            });
        }
    };
    HSCarousel.prototype.setCurrentDot = function () {
        var _this = this;
        var toggleDotActive = function (el, i) {
            var statement = false;
            var itemsQty = Math.floor(_this.getCurrentSlidesQty() / 2);
            if (_this.isSnap && !_this.hasSnapSpacers) {
                statement =
                    i ===
                        (_this.getCurrentSlidesQty() % 2 === 0
                            ? _this.currentIndex - itemsQty + 1
                            : _this.currentIndex - itemsQty);
            }
            else
                statement = i === _this.currentIndex;
            if (statement)
                el.classList.add('active');
            else
                el.classList.remove('active');
        };
        if (this.dotsItems)
            this.dotsItems.forEach(function (el, i) { return toggleDotActive(el, i); });
        else
            this.dots
                .querySelectorAll(':scope > *')
                .forEach(function (el, i) { return toggleDotActive(el, i); });
    };
    HSCarousel.prototype.setElementToDisabled = function (el) {
        el.classList.add('disabled');
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT')
            el.setAttribute('disabled', 'disabled');
    };
    HSCarousel.prototype.unsetElementToDisabled = function (el) {
        el.classList.remove('disabled');
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT')
            el.removeAttribute('disabled');
    };
    HSCarousel.prototype.addDisabledClass = function () {
        if (!this.prev || !this.next)
            return false;
        var gapValue = getComputedStyle(this.inner).getPropertyValue('gap');
        var itemsQty = Math.floor(this.getCurrentSlidesQty() / 2);
        var currentIndex = 0;
        var maxIndex = 0;
        var statementPrev = false;
        var statementNext = false;
        if (this.isSnap) {
            currentIndex = this.currentIndex;
            maxIndex = this.hasSnapSpacers
                ? this.slides.length - 1
                : this.slides.length - itemsQty - 1;
            statementPrev = this.hasSnapSpacers
                ? currentIndex === 0
                : this.getCurrentSlidesQty() % 2 === 0
                    ? currentIndex - itemsQty < 0
                    : currentIndex - itemsQty === 0;
            statementNext =
                currentIndex >= maxIndex &&
                    this.container.scrollLeft +
                        this.container.clientWidth +
                        (parseFloat(gapValue) || 0) >=
                        this.container.scrollWidth;
        }
        else {
            currentIndex = this.currentIndex;
            maxIndex = this.isCentered
                ? this.slides.length -
                    this.getCurrentSlidesQty() +
                    (this.getCurrentSlidesQty() - 1)
                : this.slides.length - this.getCurrentSlidesQty();
            statementPrev = currentIndex === 0;
            statementNext = currentIndex >= maxIndex;
        }
        if (statementPrev) {
            this.unsetElementToDisabled(this.next);
            this.setElementToDisabled(this.prev);
        }
        else if (statementNext) {
            this.unsetElementToDisabled(this.prev);
            this.setElementToDisabled(this.next);
        }
        else {
            this.unsetElementToDisabled(this.prev);
            this.unsetElementToDisabled(this.next);
        }
    };
    HSCarousel.prototype.autoPlay = function () {
        this.setTimer();
    };
    HSCarousel.prototype.setTimer = function () {
        var _this = this;
        this.timer = setInterval(function () {
            if (_this.currentIndex === _this.slides.length - 1)
                _this.goTo(0);
            else
                _this.goToNext();
        }, this.speed);
    };
    HSCarousel.prototype.resetTimer = function () {
        clearInterval(this.timer);
    };
    HSCarousel.prototype.detectDirection = function () {
        var _a = this.touchX, start = _a.start, end = _a.end;
        if (end < start)
            this.goToNext();
        if (end > start)
            this.goToPrev();
    };
    // Public methods
    HSCarousel.prototype.recalculateWidth = function () {
        this.sliderWidth = this.inner.parentElement.getBoundingClientRect().width;
        this.calculateWidth();
        if (this.sliderWidth !==
            this.inner.parentElement.getBoundingClientRect().width)
            this.recalculateWidth();
    };
    HSCarousel.prototype.calculateTransform = function (currentIdx) {
        if (currentIdx !== undefined)
            this.currentIndex = currentIdx;
        if (this.currentIndex > this.slides.length - this.getCurrentSlidesQty() &&
            !this.isCentered)
            this.currentIndex = this.slides.length - this.getCurrentSlidesQty();
        var containerWidth = this.sliderWidth;
        var itemWidth = containerWidth / this.getCurrentSlidesQty();
        var translateX = this.currentIndex * itemWidth;
        // TODO:: need to test auto scrolling to the end if last on resize
        if (this.isSnap && !this.isCentered) {
            if (this.container.scrollLeft < containerWidth &&
                this.container.scrollLeft + itemWidth / 2 > containerWidth)
                this.container.scrollLeft = this.container.scrollWidth;
        }
        if (this.isCentered && !this.isSnap) {
            var centeredOffset = (containerWidth - itemWidth) / 2;
            if (this.currentIndex === 0)
                translateX = -centeredOffset;
            else if (this.currentIndex >=
                this.slides.length -
                    this.getCurrentSlidesQty() +
                    (this.getCurrentSlidesQty() - 1)) {
                var totalSlideWidth = this.slides.length * itemWidth;
                translateX = totalSlideWidth - containerWidth + centeredOffset;
            }
            else
                translateX = this.currentIndex * itemWidth - centeredOffset;
        }
        if (!this.isSnap)
            this.inner.style.transform = this.isRTL
                ? "translate(".concat(translateX, "px, 0px)")
                : "translate(".concat(-translateX, "px, 0px)");
        if (this.isAutoHeight)
            this.inner.style.height = "".concat(this.slides[this.currentIndex].clientHeight, "px");
        if (this.dotsItems)
            this.goToCurrentDot();
        this.addCurrentClass();
        if (!this.isInfiniteLoop)
            this.addDisabledClass();
        if (this.isSnap && this.hasSnapSpacers)
            this.buildSnapSpacers();
        if (this.infoCurrent)
            this.setInfoCurrent();
    };
    HSCarousel.prototype.setTranslate = function (val) {
        this.inner.style.transform = this.isRTL
            ? "translate(".concat(-val, "px, 0px)")
            : "translate(".concat(val, "px, 0px)");
    };
    HSCarousel.prototype.goToPrev = function () {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
        else {
            this.currentIndex = this.slides.length - this.getCurrentSlidesQty();
        }
        if (this.isSnap) {
            var itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            this.container.scrollBy({
                left: Math.max(-this.container.scrollLeft, -itemWidth),
                behavior: 'smooth',
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop)
                this.addDisabledClass();
        }
        else
            this.calculateTransform();
        if (this.dots)
            this.setCurrentDot();
    };
    HSCarousel.prototype.goToNext = function () {
        var statement = this.isCentered
            ? this.slides.length -
                this.getCurrentSlidesQty() +
                (this.getCurrentSlidesQty() - 1)
            : this.slides.length - this.getCurrentSlidesQty();
        if (this.currentIndex < statement) {
            this.currentIndex++;
        }
        else {
            this.currentIndex = 0;
        }
        if (this.isSnap) {
            var itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            var maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
            this.container.scrollBy({
                left: Math.min(itemWidth, maxScrollLeft - this.container.scrollLeft),
                behavior: 'smooth',
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop)
                this.addDisabledClass();
        }
        else
            this.calculateTransform();
        if (this.dots)
            this.setCurrentDot();
    };
    HSCarousel.prototype.goTo = function (i) {
        var currentIndex = this.currentIndex;
        this.currentIndex = i;
        if (this.isSnap) {
            var itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            var index = currentIndex > this.currentIndex
                ? currentIndex - this.currentIndex
                : this.currentIndex - currentIndex;
            var width = currentIndex > this.currentIndex
                ? -(itemWidth * index)
                : itemWidth * index;
            this.container.scrollBy({
                left: width,
                behavior: 'smooth',
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop)
                this.addDisabledClass();
        }
        else
            this.calculateTransform();
        if (this.dots)
            this.setCurrentDot();
    };
    HSCarousel.prototype.setIndex = function (i) {
        this.currentIndex = i;
        this.addCurrentClass();
        if (!this.isInfiniteLoop)
            this.addDisabledClass();
    };
    // Static methods
    HSCarousel.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsCarouselCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSCarousel.autoInit = function () {
        if (!window.$hsCarouselCollection)
            window.$hsCarouselCollection = [];
        document
            .querySelectorAll('[data-hs-carousel]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsCarouselCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSCarousel(el);
        });
    };
    return HSCarousel;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSCarousel.autoInit();
    // Uncomment for debug
    // console.log('Carousel collection:', window.$hsCarouselCollection);
});
if (typeof window !== 'undefined') {
    window.HSCarousel = HSCarousel;
}
exports.default = HSCarousel;
